export { View } from './View';
export type { Props, PolymorphicProps } from './View.types';
